<div class="data-card-body position-relative">
  <!-- Loader -->
  <nz-spin nzTip="Loading..." [nzSpinning]="isLoading.mo"></nz-spin>

  <!-- Main Object -->
  <ng-container *ngIf="mo && !isLoading.mo">
    <!-- Display Data -->
    <ng-container *ngIf="moData; else noAvailableData">
      <app-data-valve
        *ngIf="moType === 'VLV'"
        (openSDLEvent)="onOpenNewMO($event)"
        [hasCMMSPackage]="hasCMMSPackage()"
        [hasRCAFPackage]="hasRCAFPackage()"
        [data]="moDataFE"
        [filter]="filter"
        [ttmURLParams]="getTravelTimeMonitoringURLParams(mo)"></app-data-valve>

      <app-data-breaker
        *ngIf="moType === 'BRK'"
        (openSDLEvent)="onOpenNewMO($event)"
        [hasCMMSPackage]="hasCMMSPackage()"
        [hasRCAFPackage]="hasRCAFPackage()"
        [data]="moDataFE"
        [filter]="filter"
        [ttmURLParams]="getTravelTimeMonitoringURLParams(mo)"></app-data-breaker>

      <app-data-fd
        *ngIf="moType === 'FD_FE_MOT_NFS'"
        (openSDLEvent)="onOpenNewMO($event)"
        [hasCMMSPackage]="hasCMMSPackage()"
        [hasRCAFPackage]="hasRCAFPackage()"
        [data]="moDataFE"
        [filter]="filter"
        [ttmURLParams]="getTravelTimeMonitoringURLParams(mo)"></app-data-fd>

      <app-data-process-transmitters
        *ngIf="moType === 'PT'"
        (openSDLEvent)="onOpenNewMO($event)"
        [hasCMMSPackage]="hasCMMSPackage()"
        [hasRCAFPackage]="hasRCAFPackage()"
        [data]="moDataPT"
        [filter]="filter"></app-data-process-transmitters>

      <app-data-binary-process-ini
        *ngIf="moType === 'BPI'"
        (openSDLEvent)="onOpenNewMO($event)"
        [hasCMMSPackage]="hasCMMSPackage()"
        [hasRCAFPackage]="hasRCAFPackage()"
        [data]="moDataBPI"
        [filter]="filter"></app-data-binary-process-ini>

      <app-data-flame-gas
        *ngIf="moType === 'FGD'"
        [hasCMMSPackage]="hasCMMSPackage()"
        [hasRCAFPackage]="hasRCAFPackage()"
        [data]="moDataFGD"
        [filter]="filter"></app-data-flame-gas>

      <app-data-binary-fg-ini
        *ngIf="moType === 'BFGI'"
        [hasCMMSPackage]="hasCMMSPackage()"
        [hasRCAFPackage]="hasRCAFPackage()"
        [data]="moDataBFGI"
        [filter]="filter"></app-data-binary-fg-ini>

      <app-data-sdl
        *ngIf="moType === 'SDL'"
        [hasCMMSPackage]="hasCMMSPackage()"
        [data]="moDataSDL"
        [filter]="filter"></app-data-sdl>
    </ng-container>

    <!-- Data Card FORM -->
    <ng-container *ngIf="displayMainForm() || displayDeviationURLForm()">
      <app-form-main
        [disabledMainFormControls]="!canSaveDataCard()"
        [displayMainForm]="displayMainForm()"
        [displayUrlForm]="displayDeviationURLForm()"
        [mainFormData]="moDataFE"
        [urlFormData]="deviationURLData"
        [dataCardType]=moType
        [mainObject]="mo"
        (notifyDataCard)="onNotifyDataCardMainForm($event)"
        (notifyUrlDataCard)="onNotifyDataCardDevUrl($event)"></app-form-main>
    </ng-container>
  </ng-container>
</div>

<!-- Templates -->
<ng-template #noAvailableData>
  <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="true" nzShowIcon="true"></nz-alert>
</ng-template>
